module.exports = "<svg viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.80273 0.643349L7 1.45127L9.58203 4L10.3604 3.21674C11.2129 2.35894 11.2129 1.50114 10.3604 0.643349C9.50781 -0.214447 8.65527 -0.214447 7.80273 0.643349ZM0 12V9.09232L6.40332 2L9 4.9399L2.625 12H0ZM5 12L5.875 11H12V12H5Z\" fill=\"black\" fill-opacity=\"0.3\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/SidebarInfoBlock/edit-icon.svg
// module id = 2038
// module chunks = 0